
import {
  mdiAbTesting,
  mdiAccountCash,
  mdiAccountCircle,
  mdiAccountCircleOutline,
  mdiAccountDetails,
  mdiAccountGroup,
  mdiAccountOutline,
  mdiAlertOctagonOutline,
  mdiAlertOutline,
  mdiArrowLeft,
  mdiBackspace,
  mdiBackspaceOutline,
  mdiBookOpenVariant,
  mdiBookshelf,
  mdiCalendar,
  mdiCancel,
  mdiCash100,
  mdiCashRefund,
  mdiCashRegister,
  mdiCheckBold,
  mdiCheckboxBlankCircle,
  mdiCheckboxBlankCircleOutline,
  mdiCheckCircleOutline,
  mdiChevronLeft,
  mdiChevronRight,
  mdiCircle,
  mdiCircleHalfFull,
  mdiCircleMultipleOutline,
  mdiCircleOutline,
  mdiClockIn,
  mdiClockOut,
  mdiClockOutline,
  mdiClose,
  mdiCog,
  mdiCommentQuestionOutline,
  mdiCreditCardOutline,
  mdiDatabase,
  mdiDeleteOutline,
  mdiDialpad,
  mdiDotsHorizontal,
  mdiDotsVertical,
  mdiEmailOutline,
  mdiEye,
  mdiEyeOff,
  mdiFormatListBulletedSquare,
  mdiFormatListCheckbox,
  mdiGestureTap,
  mdiGlassCocktail,
  mdiHelpCircle,
  mdiInboxArrowDown,
  mdiInboxArrowUp,
  mdiInformationOutline,
  mdiLock,
  mdiLockOpen,
  mdiLockOutline,
  mdiLogout,
  mdiMagnify,
  mdiMagnifyClose,
  mdiMenuDown,
  mdiMenuLeft,
  mdiMenuRight,
  mdiMinus,
  mdiMinusCircleOutline,
  mdiNoteEditOutline,
  mdiNoteTextOutline,
  mdiNull,
  mdiPartyPopper,
  mdiPencil,
  mdiPercentOutline,
  mdiPin,
  mdiPlus,
  mdiPlusCircleOutline,
  mdiPound,
  mdiPrinterPos,
  mdiRecord,
  mdiRefresh,
  mdiShopping,
  mdiSilverwareForkKnife,
  mdiSlashForward,
  mdiSync,
  mdiSyncAlert,
  mdiTableChair,
  mdiViewDashboard,
  mdiViewList,
  mdiWeb,
} from '@mdi/js'

const state = {
  null: mdiNull,
  revo: 'M16.906 5.185c.554 0 1.092.068 1.606.184V1.137A12.48 12.48 0 0016.756 1C10.57 1 5.466 5.529 5 11.302V23h4.739V12.398c.016-.37.047-.736.095-1.096h-.008c.435-3.457 3.425-6.117 7.08-6.117',
  kitchen: 'M12.5 1.5c-1.727 0-3.167 1.124-3.828 2.693-.452-.16-.91-.31-1.397-.31C4.92 3.883 3 5.81 3 8.173c0 1.803 1.348 3.346 3 3.968V21a1 1 0 0 0 1 1h11a1 1 0 0 0 1-1v-8.863c1.652-.622 3-2.161 3-3.963 0-2.364-1.92-4.291-4.275-4.291-.488 0-.945.15-1.397.31C15.667 2.623 14.227 1.5 12.5 1.5Zm0 1.369c2.037 0 2.5.899 3.218 2.95 2.863-1.497 4.741.25 4.782 2.355 0 1.272-.791 2.826-3 2.826v6.5h-10V11c-2.184 0-2.984-1.517-3-2.826 0-2.572 2.182-3.644 4.795-2.342C10 3.577 10.541 2.869 12.5 2.869ZM11.75 9v7h1.5V9ZM8.5 11v5H10v-5zm6.5 0v5h1.5v-5zm-7.5 8h10v1.5h-10z',

  // Alerts
  error: mdiAlertOctagonOutline,
  success: mdiCheckCircleOutline,
  warning: mdiAlertOutline,
  info: mdiInformationOutline,

  // Navigation
  action: mdiMenuRight,
  back: mdiArrowLeft,
  cancel: mdiCancel,
  close: mdiClose,
  delete: mdiDeleteOutline,
  done: mdiCheckBold,
  edit: mdiPencil,
  minus: mdiMinus,
  minusCircle: mdiMinusCircleOutline,
  moreHorizontal: mdiDotsHorizontal,
  moreVertical: mdiDotsVertical,
  next: mdiChevronRight,
  plus: mdiPlus,
  plusCircle: mdiPlusCircleOutline,
  prev: mdiChevronLeft,
  reload: mdiRefresh,
  search: mdiMagnify,
  searchClose: mdiMagnifyClose,

  // Drawer
  history: mdiPin,
  tpvMode: mdiShopping,
  eventMode: mdiPartyPopper,
  cashier: mdiCashRegister,
  preferences: mdiCog,
  fiscal: mdiBookshelf,
  help: mdiHelpCircle,
  logout: mdiLogout,

  // Other
  account: mdiAccountCircle,
  activeRoom: mdiMenuDown,
  backspace: mdiBackspace,
  backspaceOutline: mdiBackspaceOutline,
  calendar: mdiCalendar,
  cash: mdiCash100,
  cashIn: mdiInboxArrowDown,
  cashOut: mdiInboxArrowUp,
  circleBlank: mdiCheckboxBlankCircleOutline,
  circleFull: mdiCheckboxBlankCircle,
  clock: mdiClockOutline,
  clockIn: mdiClockIn,
  clockOut: mdiClockOut,
  coins: mdiCircleMultipleOutline,
  container: mdiDatabase,
  creditCard: mdiCreditCardOutline,
  customer: mdiAccountDetails,
  divide: mdiAbTesting,
  dot: mdiRecord,
  email: mdiEmailOutline,
  eye: mdiEye,
  eyeOff: mdiEyeOff,
  guests: mdiAccountGroup,
  guide: mdiBookOpenVariant,
  hash: mdiPound,
  kit: mdiFormatListBulletedSquare,
  kitchenNote: mdiNoteEditOutline,
  left: mdiMenuLeft,
  list: mdiFormatListCheckbox,
  locale: mdiWeb,
  lock: mdiLock,
  lockScreen: mdiDialpad,
  loginLock: mdiLockOutline,
  loginUser: mdiAccountOutline,
  menu: mdiSilverwareForkKnife,
  order: mdiNoteTextOutline,
  percent: mdiPercentOutline,
  print: mdiPrinterPos,
  printStatus0: mdiCircleOutline,
  printStatus1: mdiCircleHalfFull,
  printStatus2: mdiCircle,
  refund: mdiCashRefund,
  sellingFormat: mdiGlassCocktail,
  slash: mdiSlashForward,
  support: mdiCommentQuestionOutline,
  sync: mdiSync,
  syncAlert: mdiSyncAlert,
  table: mdiTableChair,
  tap: mdiGestureTap,
  tip: mdiAccountCash,
  unlock: mdiLockOpen,
  user: mdiAccountCircleOutline,
  viewList: mdiViewList,
  viewRooms: mdiViewDashboard,
}

export default { state }
